import { createGlobalStyle } from 'styled-components';
import 'antd/lib/style/index.css';

export const SiteStyles = createGlobalStyle``;
